export default {"src":"/_next/static/media/burningMoney_40.49c24694.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};